import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Title, Luggage, Icon, Division, Restrictions } from './styles';

interface Props {
  restrictions?: string;
  handBaggage?: boolean;
}

const FlightSectorBaggage = ({ restrictions, handBaggage }: Props) => {
  const { t } = useStoreTranslation();

  const haveWarehouseBaggage = !restrictions?.startsWith('0');

  return (
    <Container>
      <Title>{t('flightSectorBaggage.title')}</Title>

      <Luggage className="include">
        <Icon src="/images/luggages/backpack-active.svg" />
        {t('flightSectorBaggage.includedPersonalBaggage')}
      </Luggage>

      <Division />

      <Luggage className={handBaggage ? 'include' : ''}>
        <Icon src={`/images/luggages/hand-luggage${handBaggage ? '-active' : ''}.svg`} />
        {t(handBaggage ? 'flightSectorBaggage.includedHandBaggage' : 'flightSectorBaggage.notIncludedHandBaggage')}
      </Luggage>

      <Division />

      <Luggage className={haveWarehouseBaggage ? 'include' : ''}>
        <Icon src={`/images/luggages/warehouse-luggage${haveWarehouseBaggage ? '-active' : ''}.svg`} />
        {t(
          haveWarehouseBaggage
            ? 'flightSectorBaggage.includedWarehouseBaggage'
            : 'flightSectorBaggage.notIncludedWarehouseBaggage',
        )}
      </Luggage>

      <Restrictions>
        {t(haveWarehouseBaggage ? 'flightSectorBaggage.restriction' : 'flightSectorBaggage.buyWarehouseBaggage', {
          restrictions,
        })}
      </Restrictions>
    </Container>
  );
};

export default FlightSectorBaggage;
